import { getTarget } from 'Dictionaries/target.js';

export default {
    methods: {
        getTargetLabel(data) {
            const type = data.linkedObject?.subtype ?? data.linkedObject?.type;
            return type ? getTarget(type) : '';
        },
    },
};
